import React from 'react';
import { useAppSelector } from '../../../store';
import { Link } from 'react-router-dom';
import ProgressBaar from '../../../components/progressBar';

interface IEmployee {
    photo: string;
    id: string;
    name: string;
    surname: string;
    position: string;
    icons: [string];
    fullnessRatio: number;
}

interface IEmployeeCard {
    employee: IEmployee;
}
const EmployeeCard = (props: IEmployeeCard) => {
    const { words } = useAppSelector(state => state.localization);

    

    return (

        <div className="micro-card-04" >

            <Link className="c-item-01" to={props?.employee?.id?.length > 0 ? '/profile?u=' + props?.employee?.id : '#!'}>
                <img className={props?.employee?.photo ? "c-item-01-A active" : "c-item-01-A"} src={props?.employee?.photo ? props?.employee?.photo : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'} />
                <div className="c-item-01-B">
                    <p className="c-unit-01">{(props?.employee?.name || '') + ' ' + (props?.employee?.surname || '')}</p>
                    <p className="c-unit-02">{props?.employee?.position || ''}</p>
                    <p className="c-unit-03">
                        {words && words['WEB.showAllProfile']}
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.21387 6.5V9.5C9.21387 9.76522 9.10851 10.0196 8.92097 10.2071C8.73344 10.3946 8.47908 10.5 8.21387 10.5H2.71387C2.44865 10.5 2.1943 10.3946 2.00676 10.2071C1.81922 10.0196 1.71387 9.76522 1.71387 9.5V4C1.71387 3.73478 1.81922 3.48043 2.00676 3.29289C2.1943 3.10536 2.44865 3 2.71387 3H5.71387"
                                stroke="#7E7E92"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M7.71387 1.5H10.7139V4.5" stroke="#7E7E92" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.21387 7L10.7139 1.5" stroke="#7E7E92" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </p>
                    <div className="c-unit-04">
                       
                    </div>
                </div>
            </Link>
            <ProgressBaar color={false} percent={props?.employee?.fullnessRatio} title="Profil Doluluk"/>
            <hr className='c-item-02' />
            <div className="c-item-03">
                {
                    props?.employee?.icons?.length > 0 && props?.employee?.icons &&
                    props?.employee?.icons?.map((icon, index) => (
                        <div key={index} className="c-item-03-A">
                            <img src={icon} alt="icon" />
                        </div>
                    ))
                }
            </div>
            {
                !props.employee?.icons.length &&
                <p className="c-item-04">{words && words['WEB.teamsTextForUpdate']}</p>
            }

        </div>

    );
};

export default EmployeeCard;
